export default __webpack_public_path__ + "static/media/square-purple-1.e61fd875.png";